module.exports = require("./jgo-CM.js");